import { Box, Stack, Text } from '@mantine/core'
import React from 'react'
import ReportItem from '../ReportItem'

interface LimitHighConsumptionCaseProps {
  number: number
  item: any
}

export default function LimitHighConsumptionCase({ number, item }: LimitHighConsumptionCaseProps) {
  const cardBackgroundColor = '#ffffff'

  return (
    <Box
      style={{
        backgroundColor: cardBackgroundColor,
        padding: 'var(--mantine-spacing-xs)',
        borderRadius: 'var(--mantine-radius-sm)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.05)',
        marginBottom: 'var(--mantine-spacing-xs)',
      }}
    >
      <Stack gap={'xs'} className={'text-gray-500'}>
        <Text size={'sm'} c={'dark'} fw={500}>
          案件（{number}）
        </Text>

        <ReportItem name={'案件ID'} value={item?.id} />
        <ReportItem name={'案号'} value={item?.caseCode} />
        <ReportItem name={'执行法院'} value={item?.courtName} />
        <ReportItem name={'发布时间'} value={item?.casePublishTime} />
      </Stack>
    </Box>
  )
}
